import type { FieldSuggestion } from '../types/framework';

const isVerified = (suggestion: FieldSuggestion) =>
  (suggestion as { verified?: boolean }).verified === true;

const sameSuggestion = (a: FieldSuggestion, b: FieldSuggestion) =>
  a.value === b.value && a.type === b.type && a.snippet === b.snippet;

/**
 * Removes identical suggestions from different plugins. The first one keeps
 * its position, but a verified copy wins over an unverified one, so e.g. a
 * date format a plugin checked is not lost behind the same guess.
 */
export const dedupeSuggestions = (suggestions: FieldSuggestion[]): FieldSuggestion[] => {
  const unique: FieldSuggestion[] = [];
  for (const suggestion of suggestions) {
    const index = unique.findIndex((kept) => sameSuggestion(kept, suggestion));
    if (index === -1) unique.push(suggestion);
    else if (isVerified(suggestion) && !isVerified(unique[index])) unique[index] = suggestion;
  }
  return unique;
};
